import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MediaBrowser } from "../project";
import arrowPng from "../../assets/icons/arrow.png";
import { projectPageUrl } from "../../lib/projectUrl";

export default function ProjectQuickLook({ project, region, onClose }) {
  const navigate = useNavigate();

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return (
    <div className="pv-backdrop" onClick={onClose}>
      <div className="pv-panel" onClick={(e) => e.stopPropagation()}>
        <header className="pv-head">
          <div>
            <h2>{project.name}</h2>
            <p>
              {[
                project.constructionType,
                project.areaSqft && `${project.areaSqft.toLocaleString()} sqft`,
                project.city,
                project.sbu,
              ]
                .filter(Boolean)
                .join(" · ")}
            </p>
          </div>

          <button className="pv-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </header>

        <MediaBrowser project={project} />

        <div className="pv-foot">
          {project.description && <p className="pv-desc">{project.description}</p>}

          {/* One way out of the quick-look: the project page, opening on Media.
              Router navigation, not a reload. SG_BACK_URL lets the page's Back
              button return here with Discover's filters intact. */}
          <button
            className="pv-viewPill"
            type="button"
            onClick={() => {
              sessionStorage.setItem(
                "SG_BACK_URL",
                `${window.location.pathname}${window.location.search}${window.location.hash}`
              );
              navigate(projectPageUrl(region, project.id));
            }}
          >
            Open project
            <img className="pv-viewPillArrow" src={arrowPng} alt="" aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  );
}
